import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CheckPageAccess } from 'src/app/components/authorize/check-page-access';
import { AddCourseDefaultValues, Course } from 'src/app/components/course/course';
import { CourseDetailsComponent } from 'src/app/components/course/course-details/course-details.component';
import { CourseStatus } from 'src/app/components/course/course-status';
import { CheckDraftMaterialForPublishedCourse, CheckDraftMaterialForPublishedCourseDefaultValues } from 'src/app/components/materials/materials';
import { CourseService } from 'src/app/services/course.service';
import { FileService } from 'src/app/services/file.service';
import { MaterialsService } from 'src/app/services/materials.service';
import { ModalService } from 'src/app/services/modal.service';
import { TagsService } from 'src/app/services/tag-service.service';
import { ToastService } from 'src/app/services/toast-service.service';

@Component({
    selector: 'app-edit-course',
    templateUrl: './edit-course.component.html',
    styleUrls: ['./edit-course.component.scss'],
    standalone: false
})

export class EditCourseComponent implements OnInit{
  course: Course = AddCourseDefaultValues();
  selectedTags: any[] = [];
  selectedPrograms: any[] = [];
  isSubmitted: boolean = false;
  id: string = '';
  courseStatus: any[] = [];
  modalSub!: Subscription;
  modalOpen = this._modalservice.getModalState();
  modalContent = '';
  modalTitle = '';
  modalOkButtonValue = 'OK';
  modalCancelButtonValue = 'CANCEL';
  modalOkButtonText = 'Ok';
  modalCancelButtonText = 'Cancel';
  pageName = CheckPageAccess.EDITCOURSE;
  selectedTab: number = 0
  checkDraftMaterialForPublishedCourse:CheckDraftMaterialForPublishedCourse=CheckDraftMaterialForPublishedCourseDefaultValues()
  hasEnrolledUsers:boolean=false
  disabledPrograms:any[]=[]

  @ViewChild('coursedetails') courseDetails!: CourseDetailsComponent;

  constructor(private _courseservice: CourseService,
    private tagservice: TagsService,
    private fileservice: FileService,
    private toastservice: ToastService,
    private router: Router,
    private route: ActivatedRoute,
  private _modalservice: ModalService,
  private _materialSerivce:MaterialsService) { }
  

  ngOnInit() {
    this.route.params.subscribe({
      next:params => {
        this.id = params['id']
        this._courseservice.hasEnrolledUsers(params['id']).subscribe({
          next: (response) => {
            this.hasEnrolledUsers = response;
          }
        });
      }
    });
 
    this._courseservice.getCourseDetailsForUpdate(this.id).subscribe({
      next: response => {
        this.course = response;
        this.course.courseType = Number(response.courseType ?? response.courseTypeId ?? response.CourseType ?? response.CourseTypeId ?? 0);
        this.selectedPrograms = response.coursePrograms;
        this.disabledPrograms = response.coursePrograms;
        this.selectedTags = response.tagId;
        this.courseDetails.course = response;

        this._courseservice.getCourseStatus(this.course.id).subscribe({
          next:(resp) => {
             this.courseStatus = resp;
             this.courseDetails.setContent(this.course.courseDescription);
           }
        });
      }
    });

    this.afterConfirmModalOps();
  }

  onSubmit() {
    this.isSubmitted = true;
    this.course.courseDescription = this.courseDetails.courseDescription;

    if (!this.validateReqFileds()) {
      this.toastservice.showErrorMessage('Please fill all the required fields');
      return;
    }

    this.course.replacementCourseId = this.courseDetails.selectedCourse.id;

    switch (this.course.courseStatus) {
      case CourseStatus.DRAFT:
        if (this.course.materialId.length == 0) {
          this.askConfirmation("Yes,Save Course", "YESSAVEDRAFTCOURSE", "No, Add Materials", "NOADDMATERIALS", "This course currently has no associated materials.Do you still wish to proceed?", "No material have been added")
        }
        else {
          this.updateCourse();
        }
        break;
      case CourseStatus.PUBLISHED:
        if (this.course.materialId.length == 0) {
          this.askConfirmation("Add Material/s", "ADDMATERIALS", "Close", "CLOSE", "This course currently has no associated materials.Published courses require at least 1 material", "No material have been added")
        }
        else{
          this.checkDraftMaterialForPublishedCourse.materials = this.course.materialId
          this._materialSerivce.checkDraftMaterialForPublishedCourse(this.checkDraftMaterialForPublishedCourse).subscribe({
            next: (resp) => {
              if(resp.status)
              {
                this.askConfirmation("Yes, Publish", "YESPUBLISH", "No, Cancel", "NOCANCEL", "Are you sure you want to set this course status to Published?Once Published, all Draft materials selected will be published and the course will be visible to participants. Editing capabilities will be limited. ", "Publish Course")
                
              }
              else
              {
                this.updateCourse();
              }
            }
          })
          
        }
        break;
        case CourseStatus.RETIRED:
          this.updateCourse();
          break;
    }


  }

  validateReqFileds(): boolean {
    var validated = true;

    if (this.course.courseName == null || this.course.courseName == '' )
      validated = false;

    if (this.course.courseDescription == null || this.course.courseDescription == '' )
      validated = false;

    if (this.course.tagId.length == 0)
      validated = false;

    if (this.course.coursePrograms.length == 0)
      validated = false;

    if (this.course.courseThumbnailFileId == 0)
      validated = false;

    if (this.course.languageId == 0)
      validated = false;

    if (this.course.courseStatus == 0)
      validated = false;

    return validated;
  }

  askConfirmation(
    okButtonText: string,
    okButtonValue: string,
    cancelButtonText: string,
    cancelButtonValue: string,
    content: string,
    title: string
  ) {
    this.modalContent = content;
    this.modalTitle = title;
    this.modalOkButtonValue = okButtonValue;
    this.modalCancelButtonValue = cancelButtonValue;
    this.modalOkButtonText = okButtonText;
    this.modalCancelButtonText = cancelButtonText;

    this._modalservice.openModal();
  }

  afterConfirmModalOps() {
    this.modalSub = this._modalservice
      .getButtonClicked()
      .subscribe((button) => {
        switch (button) {
          case 'YESSAVEDRAFTCOURSE':
            this.updateCourse();
            break;
          case 'NOADDMATERIALS':
            this.selectedTab = 1
            break;
          case 'ADDMATERIALS':
            this.selectedTab = 1
            break;
          case 'YESPUBLISH':
            this.updateCourse();
            break;
          case 'NOCANCEL':
            this._modalservice.closeModal();
            break;
          case 'CLOSE':
            this._modalservice.closeModal();
            break;
          default:
            this._modalservice.closeModal();
        }
      });
  }

  ngOnDestroy(): void {
    if (this.modalSub) {
      this.modalSub.unsubscribe();
    }
  }

  updateCourse() {
    this._courseservice.updateCourse(this.course).subscribe({
      next: (resp) => {
          if (resp.status) {
            this.toastservice.showMessage("Course Updated Successfully");
            this.router.navigate(['/course-list']);
          } else {
            this.toastservice.showErrorMessage(resp.message);
          }
        }
    });
  }

}
